<template>
    <div>
        <b-row class="mb-2" :class="row.class" v-for="row, rowIndex in rows">
            <b-col v-if="col.show === undefined || col.show === true" :class="col.class" sm="12" :lg="Core.Display.getlg(col, row.cols)" v-for="col, colIndex in row.cols">

                <b-card v-if="col.label !== '' && col.label !== undefined">
                    <div slot="header">
                        {{col.label}}
                    </div>
                    <FormRows v-model="dataFieldRefs" :fieldRefs="fieldRefs" :form="form" v-if="col.rows !== undefined" :rows="col.rows"></FormRows>
                    <FormCards v-model="dataFieldRefs" :fieldRefs="fieldRefs" :form="form" v-if="col.cards !== undefined" :cards="col.cards">
                        <slot v-for="card in col.cards" v-if="card.key !== ''" :name="card.key">
                            <slot :slot="card.key"></slot>
                        </slot>
                    </FormCards>
                    <FormFields v-model="dataFieldRefs" :fieldRefs="fieldRefs" :form="form" v-if="col.fields !== undefined" :fields="col.fields"></FormFields>
                    <FormTabs v-model="dataFieldRefs" :fieldRefs="fieldRefs" :form="form" v-if="col.tabs !== undefined" :tabs="col.tabs"></FormTabs>
                </b-card>

                <div v-else>
                    <FormRows v-model="dataFieldRefs" :fieldRefs="fieldRefs" :form="form" v-if="col.rows !== undefined" :rows="col.rows"></FormRows>
                    <FormCards v-model="dataFieldRefs" :fieldRefs="fieldRefs" :form="form" v-if="col.cards !== undefined" :cards="col.cards">
                        <slot  v-for="card in col.cards" v-if="card.key !== ''" :name="card.key">
                            <slot :slot="card.key"></slot>
                        </slot>
                    </FormCards>
                    <FormFields v-model="dataFieldRefs" :fieldRefs="fieldRefs" :form="form" v-if="col.fields !== undefined" :fields="col.fields"></FormFields>
                    <FormTabs v-model="dataFieldRefs" :fieldRefs="fieldRefs" :form="form" v-if="col.tabs !== undefined" :tabs="col.tabs"></FormTabs>
                </div>

            </b-col>
        </b-row>
    </div>

</template>

<script>

    import FormRows from './FormRows'
    import FormFields from './FormFields'
    import FormCards from './FormCards'
    import FormTabs from './FormTabs'
    export default {
      name: 'FormRows',
      components: {
          FormCards,
          FormRows,
          FormFields,
          FormTabs
      },
      props: {
          rows: {
              type: Array | Object,
              default: function() { return [] }
          },
          form: {
              type: Object,
              default: function () { return {} }
          },
          fieldRefs: {
              type: Array | Object,
              default: function() { return [] }
          },
          value: {
              type: Array | Object,
              default: function() { return [] }
          }
      },
      watch: {
          value(val) {
              this.dataFieldRefs = val
          },
          dataFieldRefs(val) {
              this.$emit('input', val)
          }
      },
      mounted() {
          this.dataFieldRefs = this.value
      },
      data: () => {
          return {
              dataFieldRefs: [],
              Core: window.Core
          }
      },
      methods: {
      }
  }
</script>